<template>
  <div class="app-content ap label">
    <div class="row mb-4">
      <div class="col-auto">
        <router-link to="/search" class="btn btn-secondary btn-svg" title="Back to search"><svg viewBox="0 0 492 492"><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></svg></router-link>
      </div>
      <div class="col">
        <div class="d-flex h-100 w-100 align-items-center">
          <h1 class="ap__main-title">Text Labeling Tool</h1>
        </div>
      </div>
    </div>
    <div class="row mb-4">

      <!-- Iframe -->
      <div class="col-lg-4">
        <div class="content-block p-0">
          <iframe :src="article.url" class="label-tool__iframe"></iframe>
        </div>
      </div>

      <!-- Transcript -->
      <div class="col-lg-4">
        <div class="content-block">
          <div class="content-block__header">
            <div class="content-block__title">Transcript</div>
          </div>
          <div class="content-block__body">
            <div class="label-tool__transcript-title">{{ article.title }}</div>
            <div class="label-transcript">
              <div class="label-transcript__backdrop" id="transcript-fake" ref="transcriptFake">
                <div class="label-transcript__highlights" v-html="transcriptWithMarks"></div>
              </div>
              <textarea v-model="article.transcript_reviewed" class="label-transcript__textarea" id="transcript" ref="transcript" spellcheck="false"></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- Meta & Label -->
      <div class="col-lg-4">
        <div class="content-block mb-4 label-tool__metadata">
          <div class="content-block__header row">
            <div class="content-block__title col">Source Metadata</div>
            <div class="content-block__actions col-auto">
              <ul>
                <li>
                  <button class="label__button label__open-browser" @click="openLink" title="Open in browser"><svg viewBox="0 0 511.626 511.627"><path d="M392.857,292.354h-18.274c-2.669,0-4.859,0.855-6.563,2.573c-1.718,1.708-2.573,3.897-2.573,6.563v91.361c0,12.563-4.47,23.315-13.415,32.262c-8.945,8.945-19.701,13.414-32.264,13.414H82.224c-12.562,0-23.317-4.469-32.264-13.414c-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562,4.471-23.313,13.417-32.259c8.947-8.947,19.702-13.418,32.264-13.418h200.994c2.669,0,4.859-0.859,6.57-2.57c1.711-1.713,2.566-3.9,2.566-6.567V82.221c0-2.662-0.855-4.853-2.566-6.563c-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648,0-42.016,8.042-58.102,24.125C8.042,113.297,0,132.665,0,155.313v237.542c0,22.647,8.042,42.018,24.123,58.095c16.086,16.084,35.454,24.13,58.102,24.13h237.543c22.647,0,42.017-8.046,58.101-24.13c16.085-16.077,24.127-35.447,24.127-58.095v-91.358c0-2.669-0.856-4.859-2.574-6.57C397.709,293.209,395.519,292.354,392.857,292.354z"/><path d="M506.199,41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948,0-9.233,1.807-12.847,5.424c-3.617,3.615-5.428,7.898-5.428,12.847s1.811,9.233,5.428,12.85l50.247,50.248L198.424,304.067c-1.906,1.903-2.856,4.093-2.856,6.563c0,2.479,0.953,4.668,2.856,6.571l32.548,32.544c1.903,1.903,4.093,2.852,6.567,2.852s4.665-0.948,6.567-2.852l186.148-186.148l50.251,50.248c3.614,3.617,7.898,5.426,12.847,5.426s9.233-1.809,12.851-5.426c3.617-3.616,5.424-7.898,5.424-12.847V54.818C511.626,49.866,509.813,45.586,506.199,41.971z"/></svg></button>
                </li>
              </ul>
            </div>
          </div>
          <div class="content-block__body">
            <form @submit.prevent="saveMetadata()" class="label__metadata">
              <div class="form-group row mb-1">
                <label for="search-engine" class="col-4 col-form-label">Search Engine</label>
                <div class="col-8">
                  <input type="text" readonly class="form-control-plaintext" id="search-engine" v-model="article.search_engine" @change="resetSave()">
                </div>
              </div>
              <div class="form-group row mb-1">
                <label for="date" class="col-4 col-form-label">Date</label>
                <div class="col-8">
                  <input type="date" class="form-control form-control-sm" id="date" v-model="article.published_date" @change="resetSave()">
                </div>
              </div>
              <div class="form-group row mb-1">
                <label for="source" class="col-4 col-form-label">Source Name</label>
                <div class="col-8">
                  <input type="text" class="form-control form-control-sm" id="source" v-model="article.source" @change="resetSave()">
                </div>
              </div>
              <div class="form-group row mb-1">
                <label for="source-url" class="col-4 col-form-label">Source URL</label>
                <div class="col-8">
                  <input type="text" class="form-control form-control-sm" id="source-url" v-model="article.source_url" @change="resetSave()">
                </div>
              </div>
              <div class="form-group row">
                <label for="language" class="col-4 col-form-label">Language</label>
                <div class="col-8">
                  <select class="form-control form-control-sm" id="language" v-model="article.language" @change="resetSave()">
                    <option value="it">Italian</option>
                    <option value="en">English</option>
                    <option value="fr">French</option>
                    <option value="es">Spanish</option>
                    <option value="de">German</option>
                    <option value="pt">Portuguese</option>
                    <option value="ru">Russian</option>
                    <option value="jp">Japanese</option>
                    <option value="zh">Chinese</option>
                    <option value="ar">Arabic</option>
                    <option value="hi">Hindi</option>
                  </select>
                </div>
              </div>
              <div class="label__tags-title">Tags</div>
              <div class="label__tags row row--less-gutters justify-space-between mb-4">
                <div class="col">
                  <div
                    @click="article.isText = !article.isText"
                    class="label__tag label__tag--text"
                    :class="{'label__tag--active': article.isText}"
                  >
                    Text
                  </div>
                </div>
                <div class="col">
                  <div
                    @click="article.isPdf = !article.isPdf"
                    class="label__tag label__tag--pdf"
                    :class="{'label__tag--active': article.isPdf}"
                  >
                    Pdf
                  </div>
                </div>
                <div class="col">
                  <div
                    @click="article.isVideo = !article.isVideo"
                    class="label__tag label__tag--video"
                    :class="{'label__tag--active': article.isVideo}"
                  >
                    Video
                  </div>
                </div>
                <div class="col">
                  <div
                    @click="article.isData = !article.isData"
                    class="label__tag label__tag--data"
                    :class="{'label__tag--active': article.isData}"
                  >
                    Data
                  </div>
                </div>
                <div class="col">
                  <div
                    @click="article.isEntity = !article.isEntity"
                    class="label__tag label__tag--entity"
                    :class="{'label__tag--active': article.isEntity}"
                  >
                    Entity
                  </div>
                </div>
                <div class="col">
                  <div
                    @click="article.isBlocked = !article.isBlocked"
                    class="label__tag label__tag--blocked"
                    :class="{'label__tag--active': article.isBlocked}"
                  >
                    Link
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-primary" :class="{'btn': true, 'btn-primary': true, 'metadata-saved': savedMetadata}">Save</button>
              </div>
            </form>
          </div>
        </div>
        <div class="mb-3" v-if="savedMetadata">
          <button class="btn btn-primary btn-sm mr-2" @click.prevent="getSelectionText()">Use Selection</button>
          <button class="btn btn-primary btn-sm" @click.prevent="cancelSelection()">Cancel Selection</button>
        </div>
        <div class="content-block mb-3" v-if="selectedText">
          <div class="content-block__header mb-3">
            <div class="content-block__title">Label Highlighted Text</div>
          </div>
          <div class="content-block__body mb-4">

            <!-- Targets -->
            <div class="row row--less-gutters mb-2">
              <div class="col">
                <div class="label__tt-title">3G & Targets</div>
              </div>
              <div class="col-auto">
                <button class="label__button label__add-tt" @click="showTargetModal" title="Select 3G & Targets"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
              </div>
            </div>
            <div v-if="selectedTargets.length == 0" class="label__no-targets">
              There are no targets, <a @click="showTargetModal">add one</a>
            </div>
            <ul class="label__targets-list" v-if="selectedTargets">
              <li v-for="target in selectedTargets" :key="target.gandtarget_id">
                <template v-if="targetlanguage === 'IT'">
                  <p>{{ target.label }}</p>
                </template>
                <template v-else>
                  <p>{{ target.label_en }}</p>
                </template>
                <button @click="removeTarget(target)"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg></button>
              </li>
            </ul>

            <!-- Taxonomies -->
            <div class="row row--less-gutters mb-2">
              <div class="col">
                <div class="label__tt-title">Taxonomies</div>
              </div>
              <div class="col-auto">
                <button class="label__button label__add-tt" @click="showTaxonomyModal" title="Select Taxonomies"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
              </div>
            </div>
            <div v-if="selectedTaxonomies.length == 0" class="label__no-targets">
              There are no taxonomies, <a @click="showTaxonomyModal">add one</a>
            </div>
            <ul class="label__taxonomies-list" v-if="selectedTaxonomies">
              <li v-for="taxonomy in selectedTaxonomies" :key="taxonomy.tax_id">
                <template v-if="taxonomylanguage === 'IT'">
                  <p>{{ taxonomy.label }}</p>
                </template>
                <template v-else>
                  <p>{{ taxonomy.label_en }}</p>
                </template>
                <button @click="removeTaxonomy(taxonomy)"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg></button>
              </li>
            </ul>

          </div>
          <div class="content-block__header mb-3">
            <div class="content-block__title">Save Paragraph to Text File</div>
          </div>
          <div class="content-block__body">
            <div class="form-group row row--less-gutters">
              <div class="col">
                <select class="form-control form-control-sm" id="folder" v-model="selectedFolder" @change="getNotes(selectedFolder)">
                  <option v-for="folder in folders" :key="folder.folder_slug" :value="folder" >{{ folder.folder_title }}</option>
                </select>
              </div>
              <div class="col-auto">
                <button @click="createFolder()" class="label__button label__add-tt" title="Add Folder"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
              </div>
            </div>
            <div class="form-group row row--less-gutters">
              <div class="col">
                <select class="form-control form-control-sm" id="note" v-model="selectedNote">
                  <option v-for="note in notes" :key="note.note_slug" :value="note" >{{ note.note_title }}</option>
                </select>
              </div>
              <div class="col-auto">
                <button @click="createNote()" class="label__button label__add-tt" title="Add Note"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
              </div>
            </div>
          </div>
          <div class="text-right">
            <button @click="saveSubnote()" class="btn btn-primary">Save</button>
          </div>
        </div>
        <div class="text-right" v-if="savedMetadata">
          <button class="btn btn-primary" @click.prevent="goToCheck()">Check</button>
        </div>
      </div>

    </div>

    <TagsModal
      v-on:childToParent="updateSelectedTarget"
      v-show="isTargetModalVisible"
      @close="closeTargetModal"
      :tagValue="'tar'"
      :modalTitle="'3G & Target'"
      :text="selectedText"
    />

    <TagsModal
      v-on:childToParent="updateSelectedTaxonomy"
      v-show="isTaxonomyModalVisible"
      @close="closeTaxonomyModal"
      :tagValue="'tax'"
      :modalTitle="'Taxonomies'"
      :text="selectedText"
    /> 
 
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import TagsModal from '@/components/TagsModal.vue';
import { 
  ARTICLE_UPDATE,
  FETCH_FOLDERS,
  FOLDER_CREATE,
  FETCH_NOTES,
  NOTE_CREATE,
  SUBNOTE_CREATE,
  FETCH_SUBNOTES 
} from "../store/actions.type";

import {
  SET_ARTICLE_SAVED
} from "../store/mutations.type";

export default {
  name: "Label",
  components: {
    TagsModal,
  },
  data() {
    return { 
      article : this.$route.params.article,
      savedMetadata: false,
      transcriptWithMarks: '',
      oldTranscriptWithMarks: '',
      selectedText: '',
      target: '',
      selectedTargets: [],
      taxonomy: '',
      selectedTaxonomies: [],
      selectedFolder: null,
      selectedNote: null,
      currentSubnotes: [],
      isTaxonomyModalVisible: false,
      isTargetModalVisible: false,
      taxonomylanguage : 'IT',
      targetlanguage  : 'IT'
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "folders", "currentFolder", "notes", "taxonomies", "targets", "subnotes", "currentArticle"])
  },
  methods: {
    getSelectionText: function() {
      var text = '';
      this.selectedText = '';
      this.transcriptWithMarks = this.oldTranscriptWithMarks;
      if (window.getSelection) {
        text = window.getSelection().toString();
      } else if (document.selection && document.selection.type != "Control") {
        text = document.selection.createRange().text;
      }
      this.selectedText = text;
      this.selectedTargets = [];
      this.selectedTaxonomies = [];
      this.selectedFolder = null;
      this.selectedNote = null;

      this.highlightSelection(this.selectedText);
    },
    handleTextareaScroll: function() {
      let transcriptDOM = this.$refs.transcript,
          transcriptDOMscrollTop = transcriptDOM.scrollTop,
          transcriptDOMfake = this.$refs.transcriptFake;
      transcriptDOMfake.scrollTop = transcriptDOMscrollTop;
    },
    cancelSelection: function(){
      this.selectedText = '';
      this.transcriptWithMarks = this.oldTranscriptWithMarks;
    },
    showTaxonomyModal() {
      this.isTaxonomyModalVisible = true;
    },
    showTargetModal() {
      this.isTargetModalVisible = true;
    },    
    closeTaxonomyModal() {
      this.isTaxonomyModalVisible = false;
    },
    closeTargetModal() {
      this.isTargetModalVisible = false;
    },    
    saveMetadata: function() {

      let vm = this;

      let errors = false;
      if(!this.article.published_date || !this.article.source || !this.article.source_url || !this.article.language) {
        errors = true;
      }

      if(errors) {
        Swal.fire(
          'Missing fields!',
          'You must select date, source name, source url and language',
          'warning'
        );
        return;
      }

      let searchData = new FormData();
      searchData.set('link_id', this.article.link_id);
      searchData.set('isData', this.article.isData);
      searchData.set('isEntity', this.article.isEntity);
      searchData.set('isPdf', this.article.isPdf);
      searchData.set('isText', this.article.isText);
      searchData.set('isVideo', this.article.isVideo);
      searchData.set('isMultilink', this.article.isMultilink);
      searchData.set('language', this.article.language);
      searchData.set('published_date', this.article.published_date + "T00:00:00Z");
      searchData.set('source', this.article.source);
      searchData.set('source_url', this.article.source_url);
      searchData.set('title', this.article.title);
      searchData.set('transcript_reviewed', this.article.transcript_reviewed);
      
      this.$store.dispatch(ARTICLE_UPDATE, searchData)
      .then(() => {

        this.$store.commit(SET_ARTICLE_SAVED, this.article.link_id);

        Swal.fire(
          'Saved!',
          'Source metadata has been saved.',
          'success'
        );
        vm.savedMetadata = true;
      });     
    },
    addTarget: function() {
      if(this.selectedTargets.indexOf(this.target) === -1) {
        this.selectedTargets.push(this.target)
      }
      this.target = '';
    },
    removeTarget: function(target) {
      var targetIndexToRemove = this.selectedTargets.indexOf(target);

      if (targetIndexToRemove > -1) {
        this.selectedTargets.splice(targetIndexToRemove, 1);
      }
    },
    addTaxonomy: function() {
      if(this.selectedTaxonomies.indexOf(this.taxonomy) === -1) {
        this.selectedTaxonomies.push(this.taxonomy)
      }
      this.taxonomy = '';
    },
    removeTaxonomy: function(taxonomy) {
      var taxonomyIndexToRemove = this.selectedTaxonomies.indexOf(taxonomy);

      if (taxonomyIndexToRemove > -1) {
        this.selectedTaxonomies.splice(taxonomyIndexToRemove, 1);
      }
    },
    createFolder: function() {
      Swal.fire({
        title: 'Add folder',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: (folderTitle) => {
          if(folderTitle == '') {
            return Swal.showValidationMessage(
              "Type folder name"
            )
          }
          let folderData = new FormData();
          folderData.set('folder_title', folderTitle);

          return this.$store.dispatch(FOLDER_CREATE, folderData);
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if(result.value.error) {
          Swal.fire(
            'Error!',
            result.value.error.message,
            'error'
          )
        } else {
          this.selectedFolder = result.value;
          Swal.fire(
            'Created!',
            'Your folder has been created.',
            'success'
          )
        }
      });
    },
    getNotes: function(folder) {
      return this.$store.dispatch(FETCH_NOTES, folder);
    },
    createNote: function() {
      if(this.selectedFolder) {
        Swal.fire({
          title: 'Add Note',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Add',
          showLoaderOnConfirm: true,
          preConfirm: (noteTitle) => {
            if(noteTitle == '') {
              return Swal.showValidationMessage(
                "Type note name"
              )
            }
            let noteData = new FormData();
            noteData.set('note_title', noteTitle);

            let folderData = {
              'folder_title': this.selectedFolder.folder_title
            }
            noteData.set('folder', JSON.stringify(folderData));

            let payload = {
              'folder': this.selectedFolder,
              'note': noteData
            }

            return this.$store.dispatch(NOTE_CREATE, payload);
          },
          allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
          if(result.value.error) {
            Swal.fire(
              'Error!',
              result.value.error.message,
              'error'
            )
          } else {
            this.selectedNote = result.value;
            Swal.fire(
              'Created!',
              'Your note has been created.',
              'success'
            )
          }
        });
      }
    },
    saveSubnote: function() {
      if(this.selectedTaxonomies.length == 0 
      || this.selectedTargets.length == 0
      || this.selectedFolder == null
      || this.selectedNote == null) {
        Swal.fire(
          'Missing fields!',
          'You must to populate all the fields',
          'warning'
        );
        return;
      }

      let errorGender = true;
      let errorGeolocalization = true;
      let errorGeneration = true;
      // let errorTarget = true;
 
      let idGender = null;
      let idGeolocalization = null;
      let idGeneration = null;
      // let idTarget = null;

      for (var l = this.targets.length - 1; l >= 0; l--) {
        if(this.targets[l].label == 'GENERE') {
          idGender = this.targets[l].gandtarget_id;
        }
        if(this.targets[l].label == 'GEOLOCALIZZAZIONE') {
          idGeneration = this.targets[l].gandtarget_id;
        }
        if(this.targets[l].label == 'GENERAZIONE') {
          idGeolocalization = this.targets[l].gandtarget_id;
        }
        // if(this.targets[l].label == 'TARGET') {
        //   idTarget = this.targets[l].gandtarget_id;
        // }
      }

      for (var k = this.selectedTargets.length - 1; k >= 0; k--) {
        if(this.selectedTargets[k].lev_1 == idGender) {
          errorGender = false;
        }
        if(this.selectedTargets[k].lev_1 == idGeolocalization) {
          errorGeolocalization = false;
        }
        if(this.selectedTargets[k].lev_1 == idGeneration) {
          errorGeneration = false;
        }
        // if(this.selectedTargets[k].lev_1 == idTarget) {
        //   errorTarget = false;
        // }
      }
      if(errorGender || errorGeolocalization || errorGeneration) {
         Swal.fire(
          'Missing fields!',
          'You must select gender, geolocalization and generation',
          'warning'
        );
        return;
      }

      let subNoteData = new FormData();
      subNoteData.set('text', this.selectedText);
      for (var i = 0; i < this.selectedTaxonomies.length; i++) {
        subNoteData.append('taxonomies', this.selectedTaxonomies[i].tax_id);
      }
      for (var j = 0; j < this.selectedTargets.length; j++) {
        subNoteData.append('targets', this.selectedTargets[j].gandtarget_id);
      }
      // subNoteData.set('targets', this.selectedTargets);
      subNoteData.set('note', this.selectedNote.note_id);
      subNoteData.set('link', this.article.link_id);

      let payload = {
        'folder_slug' : this.selectedFolder.folder_slug,
        'note_slug' : this.selectedNote.note_slug,
        'subNoteData' : subNoteData
      }

      this.$store.dispatch(SUBNOTE_CREATE, payload)
      .then(() => {
        Swal.fire(
        'Saved!',
        'Subnote has been saved.',
        'success'
        );
        //this.currentSubnotes.push(this.selectedText);
        this.updateSingleTranscriptWithMarks(this.selectedText);
        this.selectedText = '';     
      });     
    },
    updateTranscriptWithMarks: function() {
      for (var i = this.currentSubnotes.length - 1; i >= 0; i--) {
        let searchTextCleaned = this.currentSubnotes[i].replace(/[.*+?^${}()|[\]\\]/g, "\\$&");    
        let regex = new RegExp(searchTextCleaned,'g');
        // let regex = new RegExp(this.currentSubnotes[i],'g');
        let replaceString = '<mark>' + this.currentSubnotes[i] + '</mark>';
        this.transcriptWithMarks = this.transcriptWithMarks.replace(regex, replaceString);
        this.transcriptWithMarks = this.transcriptWithMarks + '\n'; // Fix
      }
      this.oldTranscriptWithMarks = this.transcriptWithMarks;
    },
    updateSingleTranscriptWithMarks: function(selectedText) {
      let selectedTextCleaned = selectedText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");    
      let regex = new RegExp(selectedTextCleaned,'g');
      let replaceString = '<mark>' + selectedText + '</mark>';
      this.transcriptWithMarks = this.oldTranscriptWithMarks.replace(regex, replaceString);
      this.transcriptWithMarks = this.transcriptWithMarks + '\n'; // Fix
      this.oldTranscriptWithMarks = this.transcriptWithMarks;
    },
    highlightSelection: function(selectedText) {
      let selectedTextCleaned = selectedText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      let regex = new RegExp(selectedTextCleaned,'g');
      let replaceString = '<mark class="current-selection">' + selectedText + '</mark>';
      this.transcriptWithMarks = this.transcriptWithMarks.replace(regex, replaceString);
      this.transcriptWithMarks = this.transcriptWithMarks + '\n'; // Fix
    },            
    openLink: function() {
      window.open(this.article.url);
    },
    goToCheck: function() {
      this.$router.push({
        name: "Check", params: {
          article: this.article,
          folder: null,
          returnTo: '/label'
        }
      })
    },
    updateSelectedTaxonomy (value) {
      if(value.lev_2 == '') {
        Swal.fire(
          'Error!',
          'Select a valid option',
          'error'
        ) 
      } else {
        if(!this.selectedTaxonomies.includes(value)){
          this.selectedTaxonomies.push(value);        
          // Swal.fire(
          //   'Success!',
          //   'The ' + value.label + ' taxonomy has been added',
          //   'success'
          // )
        } else {
          Swal.fire(
            'Error!',
            value.label + ' was already present',
            'error'
          )       
        }
      }
    },
    updateSelectedTarget(value) {
      if(value.lev_2 == '') {
        Swal.fire(
          'Error!',
          'Select a valid option',
          'error'
        ) 
      } else {
        if(!this.selectedTargets.includes(value)){
          this.selectedTargets.push(value);       
          // Swal.fire(
          //   'Success!',
          //   'The ' + value.label + ' target has been added',
          //   'success'
          // )
        } else {
          Swal.fire(
            'Error!',
            value.label + ' was already present',
            'error'
          )       
        }
      }
    },
    resetSave() {
      this.savedMetadata = false;
    }
  },
  created() {
    
  },  
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    this.article = this.currentArticle;

    if (!this.article) {
      this.$router.push({ name: "Search" });
      return;
    }

    if(Object.keys(this.folders).length === 0) {
      this.$store.dispatch(FETCH_FOLDERS);
    }

    if(this.article.vueSaved) {
      this.savedMetadata = true;
    }

    if(this.article.isReviewed) {
      this.savedMetadata = true;
    }

    if(this.article.published_date) {
      this.article.published_date = this.article.published_date.split('T')[0];
    }

    let payload = {
      'link_id' : this.article.link_id
    }
    this.$store.dispatch(FETCH_SUBNOTES, payload);
    // .then(() => {
    //   if(this.subnotes.length > 0) {
    //     for (var i = 0; i < this.subnotes.length; i++) {
    //       this.currentSubnotes.push(this.subnotes[i].text);
    //     }
    //     this.transcriptWithMarks = this.article.transcript;
    //     this.updateTranscriptWithMarks(); 
    //   }
    // });

    this.oldTranscriptWithMarks = this.article.transcript_reviewed;

    this.$nextTick(() => {
      let transcriptDOM = this.$refs.transcript;
      transcriptDOM.addEventListener('scroll', this.handleTextareaScroll);
    });
  },
  watch: {
    subnotes() {
      if(this.subnotes.length > 0) {
        for (var i = 0; i < this.subnotes.length; i++) {
          this.currentSubnotes.push(this.subnotes[i].text);
        }
        this.transcriptWithMarks = this.article.transcript_reviewed;
        this.updateTranscriptWithMarks(); 
      }
    }
  }
}
</script>

<style lang="scss">

.label-transcript {
  position: relative;
  height: rem(500px);
  font-family: $font-family-roboto;

  &__backdrop {
    height: rem(500px);
    width: 100%;
    position: absolute;
    z-index: 1;
    background-color: #fff;
    overflow-y: scroll;
    pointer-events: none;
    font-size: rem(14px);
    transition: transform 1s;
  }

  &__highlights {
    white-space: pre-wrap;
    word-wrap: break-word;
    color: transparent;

    mark {
      color: transparent;
      background-color: lighten($color-java, 25%);
      padding: 0;
    }

    mark.current-selection {
      background-color: lighten($color-sunset, 25%);
    }
  }

  &__textarea {
    display: block;
    position: absolute;
    z-index: 2;
    margin: 0;
    border: 0;
    padding: 0;
    color: #444;
    width: 100%;
    height: rem(500px);
    font-size: rem(14px);
    background-color: transparent;
    overflow: auto;
    resize: none;
    transition: transform 1s;
  }
}

.label {

  &__button {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    svg {
      width: rem(28px);
      height: rem(28px);
      transition: fill .3s ease;
    }

    &:focus {
      outline: none;
    }
  }

  &__open-browser {

    svg {
      width: rem(20px);
      height: rem(20px);
      fill: $color-genoa;
    }
    
    &:hover {

      svg {
        fill: $color-java;
      }
    }
  }

  &__add-tt {

    svg {
      width: rem(20px);
      height: rem(20px);
      fill: $color-genoa;
    }
    
    &:hover {

      svg {
        fill: $color-java;
      }
    }
  }

  &__metadata {
    font-family: $font-family-roboto;
    color: #000;

    label {
      font-weight: 700;
    }
  }

  &__tags-title {
    font-size: rem(16px);
    color: #000;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: rem(12px);
  }

  &__tags {
    margin-bottom: 0;
    padding: 0;
    list-style: none;
    margin-left: -2px;
    margin-right: -2px;

    .col {
      padding-left: 2px;
      padding-right: 2px;
    }
  }

  &__tag {
    font-weight: 700;
    background-color: #f1f1f1;
    text-transform: uppercase;
    padding: rem(4px) rem(8px);
    font-size: rem(12px);
    color: #999;
    text-align: center;

    &:not(:last-child) {
      margin-bottom: rem(4px);
    }
  }

  &__tag--active {
    background-color: $color-java;
    color: #fff;
  }

  &__tt-title {
    text-transform: uppercase;
    font-size: rem(15px);
    color: #000;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
  }

  &__no-targets,
  &__no-taxonomies {
    font-size: rem(13px);
    font-family: $font-family-roboto;
    color: #000;

    a {
      font-weight: 700;
      color: $color-java;
      cursor: pointer;
      transition: color .3s ease;

      &:hover {
        color: $color-genoa;
      }
    }
  }

  &__targets-list,
  &__taxonomies-list {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-bottom: rem(8px);

    li {
      margin-right: rem(8px);
      margin-bottom: rem(8px);
      padding: rem(4px) rem(8px);    
      border: 1px solid rgba(0, 0, 0, 0.2);
      display: inline-block;

      &:last-child {
        margin-right: 0;
      }

      p {
        margin-bottom: 0;
        font-size: rem(13px);
        color: $color-java;
        text-transform: uppercase;
        display: inline-block;
        margin-right: rem(8px);
      }

      button {
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        vertical-align: inherit;

        svg {
          width: rem(10px);
          height: rem(10px);
          fill: #cbcbcb;
        }
        
        &:hover {

          svg {
            fill: $color-sunset;
          }
        }
      }
    }
  }
}

.metadata-saved {
  background-color: $color-abbey !important;
  border-color: $color-abbey !important;

  &:hover {
    background-color: $color-java !important;
    border-color: $color-java !important;
  }
}

</style>